// @flow
import { get } from 'lodash';
import { Api } from '../../../helpers';
import { router } from '../../../routes/router';
import { reportError } from '@helpers/helpers';
import type
{
  Action,
  Dispatch,
  ContextState,
} from '../../../types';

// ------------------------------------
// Constants
// ------------------------------------
const REPORTS_SMS_LOADING = 'reportsSms.REPORTS_SMS_LOAD';
const REPORTS_SMS_LOADED = 'reportsSms.REPORTS_SMS_LOADED';
const REPORTS_SMS_LOADING_FAILED = 'reportsSms.REPORTS_SMS_LOADING_FAILED';


export const getReportsSms = () => (dispatch: Dispatch) => {
  dispatch({ type: REPORTS_SMS_LOADING });
  Api.get(router.getApiRoute('getReportsSms', null), {
    success: (response) => {
      dispatch({
        type: REPORTS_SMS_LOADED,
        reportData: response,
      });
    },
    error: (error) => {
      dispatch({ type: REPORTS_SMS_LOADING_FAILED, error: { message: error.message } });
      dispatch(reportError(error));
    },
  });
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reportsSmsReducer (state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case REPORTS_SMS_LOADING:
      return state
        .setIn(['reportsSms', 'isLoading'], true)
        .setIn(['reportsSms', 'errors'], null);

    case REPORTS_SMS_LOADED:
      return state
        .setIn(['reportsSms', 'isLoading'], false)
        .setIn(['reportsSms', 'data'], get(action, 'reportData', {}))
        .setIn(['reportsSms', 'errors'], null);

    case REPORTS_SMS_LOADING_FAILED:
      return state
        .setIn(['reportsSms', 'isLoading'], false)
        .setIn(['reportsSms', 'errors'], [action.error.message]);

    default:
      return state;
  }
}
